import classNames from "classnames";
import { CSSProperties, ReactNode } from "react";
import "./ContentList.scss";

const ContentList = ({
	children,
	className,
	style,
}: {
	children: ReactNode;
	className?: string;
	style?: CSSProperties;
}) => (
	<ul className={classNames("content-list", className)} style={style}>
		{children}
	</ul>
);

export default ContentList;
